var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 56.875C15.175 56.875 3.125 44.825 3.125 30C3.125 15.175 15.175 3.125 30 3.125C44.825 3.125 56.875 15.175 56.875 30C56.875 44.825 44.825 56.875 30 56.875ZM30 6.875C17.25 6.875 6.875 17.25 6.875 30C6.875 42.75 17.25 53.125 30 53.125C42.75 53.125 53.125 42.75 53.125 30C53.125 17.25 42.75 6.875 30 6.875Z",
    fill: "#1A5EEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9995 34.3875C28.9745 34.3875 28.1245 33.5375 28.1245 32.5125V31.9876C28.1245 29.0876 30.2495 27.6626 31.0495 27.1126C31.9745 26.4876 32.2745 26.0626 32.2745 25.4126C32.2745 24.1626 31.2495 23.1375 29.9995 23.1375C28.7495 23.1375 27.7246 24.1626 27.7246 25.4126C27.7246 26.4376 26.8746 27.2876 25.8496 27.2876C24.8246 27.2876 23.9746 26.4376 23.9746 25.4126C23.9746 22.0876 26.6745 19.3875 29.9995 19.3875C33.3245 19.3875 36.0245 22.0876 36.0245 25.4126C36.0245 28.2626 33.9246 29.6876 33.1496 30.2126C32.1746 30.8626 31.8745 31.2876 31.8745 31.9876V32.5125C31.8745 33.5625 31.0245 34.3875 29.9995 34.3875Z",
    fill: "#1A5EEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 40.6125C28.95 40.6125 28.125 39.7625 28.125 38.7375C28.125 37.7125 28.975 36.8625 30 36.8625C31.025 36.8625 31.875 37.7125 31.875 38.7375C31.875 39.7625 31.05 40.6125 30 40.6125Z",
    fill: "#1A5EEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalQuestion);
export default __webpack_public_path__ + "static/media/modal-question.5a4ff83a6710696c9eb484a8d0593db2.svg";
export { ForwardRef as ReactComponent };